import { DOC_BY_PATH } from "./documentationSources";

/** Normalize a docs route segment (strip .md / README.md suffixes). */
export function normalizeDocRouteKey(raw: string): string {
  let key = raw.replace(/^\/+/, "").replace(/\/+$/, "").replace(/\\/g, "/");
  if (key.toLowerCase().endsWith("/readme.md")) {
    key = key.slice(0, -"/readme.md".length);
  } else if (key.toLowerCase().endsWith(".md")) {
    key = key.slice(0, -3);
  }
  return key;
}

/**
 * Resolve repo-relative Markdown links to in-app `/documentation/...` routes
 * when the target is part of the embedded help center.
 */
export function resolveDocHref(
  href: string | undefined,
  currentDocKey: string
): string | undefined {
  if (!href) return href;
  if (/^(https?:|mailto:|tel:|#)/i.test(href)) return href;

  const [pathPart, hash] = href.split("#");
  const basePath = currentDocKey ? `/documentation/${currentDocKey}/` : "/documentation/";
  const resolved = new URL(pathPart, `http://internal${basePath}`).pathname;
  const docKey = normalizeDocRouteKey(resolved.replace(/^\/documentation\/?/, ""));

  if (!DOC_BY_PATH[docKey]) return undefined;

  const route = docKey === "" ? "/documentation" : `/documentation/${docKey}`;
  return hash ? `${route}#${hash}` : route;
}
